module.exports = __webpack_public_path__ + "static/media/journal-whills.555f4b2a.svg";